<div class="modal-header">
  <div>
    <h4>Move {{ displayName }}</h4>
    <p class="mb-0 pe-3" style="font-size: 14px">
      Click to select a destination, double-click to navigate to subfolder
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
</div>
<div
  class="modal-body"
  style="overflow: auto !important; max-height: 60vh !important"
>
<div class="loading" *ngIf="isLoading" style="border-radius: 16px;">
  <div class="loader">Loading...</div>
</div>
  <div class="files-manager-header" style="margin: -16px; margin-bottom: 0">
    <div class="breadcrumbs">
      <div
        class="item"
        *ngFor="let folder of breadcrumbs.folders; let i = index"
      >
        <a (click)="reopenFolder(i)">{{ folder.name }}</a>
      </div>
    </div>
  </div>
  <input
    style="margin-top: 12px"
    *ngIf="showWorkspaceSelector"
    [(ngModel)]="selectedWorkspace"
    (typeaheadOnSelect)="selectWorkspace($event)"
    [typeahead]="availableWorkspaces | activeClientsOnly"
    typeaheadOptionField="name"
    [typeaheadOptionsLimit]="9999"
    [typeaheadMinLength]="0"
    placeholder="Choose a workspace"
    class="form-control"
    [adaptivePosition]="true"
    [typeaheadScrollable]="true"
    [typeaheadOptionsInScrollableView]="5"
  />

  <div
    style="margin-top: 24px"
    class="file-items"
    *ngIf="
      !showWorkspaceSelector ||
      (showWorkspaceSelector && selectedWorkspaceObj != null)
    "
  >
    <!-- Create Folder Button -->
    <div class="file-item" *ngIf="!isCreatingFolder && !isHome" (click)="startCreatingFolder()">
      <div class="file-icon create-folder"></div>
      <div class="file-name">Create Folder</div>
      <div class="file-info">
        &nbsp;
      </div>
    </div>

    <!-- Create Folder Input -->
    <div class="file-item" *ngIf="isCreatingFolder && !isHome">
      <div class="file-icon create-folder"></div>
      <input
        #newFolderInput
        type="text"
        class="form-control"
        placeholder="Folder Name"
        [(ngModel)]="newFolderName"
        (keyup.enter)="createFolder()"
        (keyup.escape)="newFolderInput.blur()"
        (blur)="createFolder()"
        style="width: calc(100%); display: inline-block; min-height: 25px !important; height: 25px !important;"
      />
      <div class="file-info">
        &nbsp;
      </div>
    </div>

    <div
      class="file-item"
      [ngClass]="{ selected: selectedFolderIndex === 1 }"
      title=""
      *ngIf="isHome"
      (dblclick)="getClientShared()"
      (click)="selectFolder('Client Shared', 'client', 1)"
    >
      <div class="file-icon clients-folder"></div>
      <div class="file-name">Client Shared</div>
      <div class="file-info">
        {{ fileCounters.all | i18nPlural: filePluralMapping }}
      </div>
    </div>
    <div
      class="file-item"
      [ngClass]="{ selected: selectedFolderIndex === 2 }"
      title=""
      *ngIf="isHome"
      (dblclick)="getStaffOnly()"
      (click)="selectFolder('Internal Folders', 'staff', 2)"
    >
      <div class="file-icon staff-folder"></div>
      <div class="file-name">Internal Folders</div>
      <div class="file-info">
        {{ fileCounters.staff | i18nPlural: filePluralMapping }}
      </div>
    </div>
    @for (folder of currentFolder.folders; track folder.uuid) {
      @if (!selectedFolders.includes(folder.uuid)) {
        <div
          class="file-item"
          [ngClass]="{ selected: selectedFolderIndex === $index + 3 }"
          title="{{ folder.name }}"
          (dblclick)="viewFolder(folder.uuid)"
          (click)="selectFolder(folder.name, folder.uuid, $index + 3)"
        >
          <div class="file-icon regular-folder"></div>
          <div class="file-name">{{ folder.name }}</div>
          <div class="file-info">
            {{ folder.file_count | i18nPlural: filePluralMapping }}
          </div>
        </div>
      }
    }
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-sm-4 text-left">
      <button type="button" class="btn btn-default" (click)="cancel()">
        Cancel
      </button>
    </div>
    <div class="col-sm-8">
      <button
        type="button"
        [disabled]="selectedFolderIndex === 0 || selectedFolder.uuid == null || isLoading"
        class="btn btn-primary"
        (click)="confirm()"
      >
        <span
          >{{ cutOrCopyAction ? "Paste in folder" : "Save in folder" }}
          {{ selectedFolder.name }}</span
        >
      </button>
    </div>
  </div>
</div>
